import { render, staticRenderFns } from "./CardBusiness.vue?vue&type=template&id=18555354&"
import script from "./CardBusiness.vue?vue&type=script&lang=js&"
export * from "./CardBusiness.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports